module.exports = __webpack_public_path__ + "img/ert.b9162543.jpg";